import React, { Component } from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import querystring from 'query-string'
import { filterRole } from '../../../actions/setting/teamblog'
import { isDescendant } from "../../../utils/DomHelper"
import WindowEventHelper from "../../../lib/WindowEventHelper";

@connect(state => ({
    selectedRole: state.teamblog.condition.role,
}), dispatch => ({
    handleFilterRole: (role) => {
        dispatch(filterRole(role))
    },
    dispatch
}))
class TeamBlogHeadFilterPanel extends Component {

    constructor() {
        super();
        this.state = {
            activateFilterList: false,
        };

        this.toggleFilterList = this.toggleFilterList.bind(this);
        this.filterRole = this.filterRole.bind(this);
        this.handleWindowClick = this.handleWindowClick.bind(this);

    }

    componentDidMount() {
		WindowEventHelper.add("click", this.handleWindowClick)
    }

    componentWillUnmount() {
		WindowEventHelper.remove("click", this.handleWindowClick)
    }

    handleWindowClick(e) {
        const { teamblogFilterPanel } = this.refs;
        let target = e.target;

        if(!isDescendant(teamblogFilterPanel, target)){
            this.setState({
                activateFilterList: false
            });
        }
    }

    toggleFilterList(e) {
        this.setState({
            activateFilterList: ! this.state.activateFilterList
        });
    }

    filterRole(role) {
        this.props.handleFilterRole(role);
        this.toggleFilterList();
    }

    render() {

        const { activateFilterList } = this.state;
        const { selectedRole }= this.props;
        let parsed = querystring.parse(location.search);
        return (
            <div ref="teamblogFilterPanel" className={classnames({opt_blog:true, opt_open:activateFilterList})}>
                <button type="button" className="btn_opt" disabled="" onClick={(e) => this.toggleFilterList(e)}>
                    보기
                    <span className="ico_blog ico_open"/>
                </button>
                <div className="layer_opt">
                    <ul className="list_opt">
                        <li className={classnames({on: (selectedRole == 'all')})}>
                            <Link
                                to={"?"}
                                onClick={(e) => this.filterRole('all')}>
                                모두 보기
                            </Link>
                        </li>
                        <li className={classnames({on: (selectedRole == 'owner')})}>
                            <Link
                                to={"?" + querystring.stringify(Object.assign({}, parsed, {role: 'owner'}))}
                                onClick={(e) => this.filterRole('owner')}>
                                소유자
                            </Link>
                        </li>
                        <li className={classnames({on: (selectedRole == 'manager')})}>
                            <Link
                                to={"?" + querystring.stringify(Object.assign({}, parsed, {role: 'manager'}))}
                                onClick={(e) => this.filterRole('manager')}>
                                관리자
                            </Link>
                        </li>
                        <li className={classnames({on: (selectedRole == 'editor')})}>
                            <Link
                                to={"?" + querystring.stringify(Object.assign({}, parsed, {role: 'editor'}))}
                                onClick={(e) => this.filterRole('editor')}>
                                편집자
                            </Link>
                        </li>
                        <li className={classnames({on: (selectedRole == 'writer')})}>
                            <Link
                                to={"?" + querystring.stringify(Object.assign({}, parsed, {role: 'writer'}))}
                                onClick={(e) => this.filterRole('writer')}>
                                필자
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }

}

export default TeamBlogHeadFilterPanel;
